import { render, staticRenderFns } from "./OfficeRoleUser.vue?vue&type=template&id=2de5175e&scoped=true&"
import script from "./OfficeRoleUser.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5175e",
  null
  
)

export default component.exports